import { Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { gsap } from 'gsap';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';
import { ConfigService } from 'src/app/services/config/config.service';
import { DomSanitizer } from '@angular/platform-browser';
@Component({
  selector: 'app-leaderboard-end-congrats',
  templateUrl: './leaderboard-end-congrats.component.html',
  styleUrls: ['./leaderboard-end-congrats.component.scss'],
})

export class LeaderboardEndCongratsPopupComponent implements OnInit,OnDestroy {
  notificationData: any; 
  private boxCounter: number = 1;
  currentPlayerRank: number;
  showWon: boolean = false;
  showNotWon: boolean = false;
  btnDisabled:boolean = false;

  lbGrantForm: FormGroup;
  lbCoinsGranted: AbstractControl<string>;
  basePath = this.config.getConfig().CDN_BASEURL + "/assets/imgs/";
  lbGrantHeaderText; 
  maxRankForShowWon: number;
  constructor(
    private navigator:Navigator,
    private navParams: NavParams,
    private balanceProvider:AccountBalanceService,
    private config:ConfigService
  ) { }

  ngOnInit() {
    this.notificationData = this.navParams.data;
    this.maxRankForShowWon = Number(this.config.getConfig().FEATURE_LB_GRANT_MAX_RANK) || 33;
    this.lbGrantForm = new FormGroup({
      lbCoinsGranted: new FormControl(''),
    });
    this.lbCoinsGranted = this.lbGrantForm.get('lbCoinsGranted');
    
    //  this.notificationData = 
    // {
    //   "id": 348,
    //   "type": "LEADERBOARD_GRANT",
    //   "title": "Leaderboard award notification",
    //   "text": "Congratulations! You have completed the Leader Board in 1 place! Your bonus total is 2475000!",
    //   "customField1": "2475000",
    //   "customField2": "1",
    //   "customField3": "19"
    // }


    if(!!this.notificationData.data){
      this.currentPlayerRank = Number(this.notificationData.data.customField2);
      if(this.currentPlayerRank  <= this.maxRankForShowWon){
        this.showWon = true;
      }else {
        this.showNotWon = true;
      }

      // if(this.currentPlayerRank === "1"){
      //   this.lbGrantHeaderText = "YOU ARE THE STARDUST LEADERBOARD CHAMPION!";
      // }
      this.lbGrantHeaderText =  this.notificationData.data.text; 
      this.lbGrantForm.get('lbCoinsGranted').setValue(this.notificationData.data.customField1);
    }
  }

  convertNewlinesToBr(text: string): string {
    return text.replace(/\n/g, '<br>');
  }
  adjustIonAppOpacity(){
    const ionPage: HTMLIonAppElement = document.querySelector('.ion-page');
    ionPage.classList.remove('overlay');
  }
  createCoin(div) {
    let box: any = document.createElement("div");
    box.classList.add('box');
    box.innerHTML = `<div class="center">
                        <img src="assets/images/chip.svg" alt="coin">
                    </div>`
    box.style.zIndex = 1000 + this.boxCounter;
    div.appendChild(box);
    this.boxCounter = this.boxCounter > 1000 ? 1 : this.boxCounter++;
    return box;
  }
  collectCoins() {
    const hourlybonus:any = document.querySelector('.button-container-lb-grant');
    const coinbar: any = document.querySelector('.navbar-shop-container-coin-animation');
    const startRect = hourlybonus.getBoundingClientRect();
    const container = document.querySelector('.coin-animation-for-lb-end');
    const endRect = coinbar.getBoundingClientRect();
    for (let i = 0; i < 25; i++) {
      const coin = this.createCoin(container);
      const addMore = (startRect.x <= 300) ? 67 : startRect.x / 2.8
      const startX = startRect.x + addMore;
      const startY = startRect.y + 10;
      const endX = endRect.x
      const endY = endRect.y

      const radiusX = 100;
      const radiusY = 60;
      const rndX = gsap.utils.random(-radiusX, radiusX, 1);
      const rndY = gsap.utils.random(-radiusY, radiusY, 1);

      gsap.set(coin, {
        x: startX,
        y: startY
      });

      gsap.to(coin, {
        duration: 0.4,
        x: startX + rndX,
        y: startY + rndY,
        ease: 'none',
      });

      gsap.to(coin, {
        duration: 0.8,
        delay: 0.1 + i * 0.01,
        x: endX + 3,
        y: endY,
        ease: 'back.in(0.5)',
        onComplete: () => {
          container.removeChild(coin);
        }
      });
    }
    // this.navigator.dismiss();
  }


  collectCoinsLoss() {
    const hourlybonus:any = document.querySelector('.button-container-lb-loss');
    const coinbar: any = document.querySelector('.navbar-shop-container-coin-animation');
    const startRect = hourlybonus.getBoundingClientRect();
    const container = document.querySelector('.coin-animation-for-lb-end');
    const endRect = coinbar.getBoundingClientRect();
    for (let i = 0; i < 25; i++) {
      const coin = this.createCoin(container);
      const addMore = (startRect.x <= 300) ? 67 : startRect.x / 2.8
      const startX = startRect.x + addMore;
      const startY = startRect.y + 10;
      const endX = endRect.x
      const endY = endRect.y

      const radiusX = 100;
      const radiusY = 60;
      const rndX = gsap.utils.random(-radiusX, radiusX, 1);
      const rndY = gsap.utils.random(-radiusY, radiusY, 1);

      gsap.set(coin, {
        x: startX,
        y: startY
      });

      gsap.to(coin, {
        duration: 0.4,
        x: startX + rndX,
        y: startY + rndY,
        ease: 'none',
      });

      gsap.to(coin, {
        duration: 0.8,
        delay: 0.1 + i * 0.01,
        x: endX + 3,
        y: endY,
        ease: 'back.in(0.5)',
        onComplete: () => {
          container.removeChild(coin);
        }
      });
    }
    // this.navigator.dismiss();
  }
  onCollect(context){
    if(context === 'grant'){
      this.collectCoins();
    }
    if(context === 'loss'){
      this.collectCoinsLoss();
    }
   
   
    this.btnDisabled = true;
    setTimeout(() => {
      this.balanceProvider.updateBalance();
      this.adjustIonAppOpacity();
      this.navigator.dismiss();
    }, 1000);
    
  }

  getTrophyImg(){
    let img;
    if(!!this.notificationData){
      switch(this.notificationData.data.customField2){
        case '1':
          img =  'imgs/prize_gold.png'
          break;
        case '2':
          img =  'imgs/prize_silver.png'
          break;
        case '3':
          img =  'imgs/prize_bronze.png'
          break;
        default:
          break;
      }
      return img;
    }
    return '';
    
  }

  ngOnDestroy(){
    if(this.notificationData?.data?.onCloseFunc){
        this.notificationData.data.onCloseFunc("closeButton");
    }
  }

}

